import { chakra } from "@chakra-ui/react";
import type { ReactNode } from "react";

// import { useGtmExternalService } from "features/ExternalServices/GoogleAnalytics/useGtm";
import ExternalServices from "features/ExternalServices";
import { EXTERNAL_SERVICE_PORTAL_IDS } from "features/ExternalServices/config";
import { useParams } from "shared/Router";
import { useIsEmbedded } from "utils";

import Header from "./Header";

export const Layout = ({ children }: { children: ReactNode }) => {
  const { propertySlug } = useParams();
  const { isEmbedded } = useIsEmbedded();

  //   const propertyData = useStore((state) => {
  //   if (!state.currentPropertyId) {
  //     return null;
  //   }

  //   return state.properties[state.currentPropertyId] ?? null;
  // });

  // Only run the query if slugs don't match (and slug exists)
  // const shouldRefetch = !!propertySlug && propertySlug !== propertyData?.slug;
  // const externalServices = propertyData?.data
  //   ?.externalServices as ExternalService[];
  // usePropertyQuery(propertySlug!, {
  //   enabled: shouldRefetch,
  // });

  // useGtmExternalService({ externalServices });

  return (
    <chakra.main>
      <ExternalServices
        propertySlug={propertySlug}
        portalIds={EXTERNAL_SERVICE_PORTAL_IDS}
      />
      {!isEmbedded && <Header propertySlug={propertySlug} />}
      <chakra.div flex={1}>{children}</chakra.div>
    </chakra.main>
  );
};
